import { ApiCoverageDetail } from '@bhtp-client-api/base';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'SelectedCoverage' })
export class SelectedCoveragePipe implements PipeTransform {
    public transform(allCoverages: ApiCoverageDetail[]): ApiCoverageDetail[] {
        return allCoverages.filter(coverage => coverage.isSelected);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/selected-coverage-pipe.ts